import dynamic from "next/dynamic";
import React from "react";

import { ContentComponentProps, PDFViewerContent } from "@/content-V2/types";

import { PDFViewerLoader } from "./PDFViewerLoader";

const PDFViewerClient = dynamic(() => import("./PDFViewerClient"), {
  ssr: false,
  loading: () => <PDFViewerLoader loading={true} />
});

export const PDFViewer: React.FC<ContentComponentProps<PDFViewerContent>> = ({ pdfUrl }) => (
  <PDFViewerClient pdfUrl={pdfUrl} />
);
